import { render, staticRenderFns } from "./barras.vue?vue&type=template&id=3abf1f76&scoped=true&"
import script from "./barras.vue?vue&type=script&lang=js&"
export * from "./barras.vue?vue&type=script&lang=js&"
import style0 from "./barras.vue?vue&type=style&index=0&id=3abf1f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf1f76",
  null
  
)

export default component.exports